// Unique per page so keep-alive destroys on eviction, stable per page so the
// out-in transition doesn't tear it out on a hash change.
export default {
  functional: true,

  render(h, { data, children }) {
    const vnode = h("router-view", data, children)

    if (data.key && vnode && vnode.componentOptions) {
      vnode.tag = `page-${data.key}`
    }

    return vnode
  }
}
